'use client';

import Image from 'next/image';
import { useTranslations } from "next-intl";
import React from 'react';

import { getBlobUrl } from '@/utils/BlobUtils';

export default function IconBgNhif() {
	const t = useTranslations('page.r-bg-dental-procedure-codes-catalog');

	return (
		<Image
			className="me-2"
			src={getBlobUrl('images/pages/home/integrations/nhif.png')}
			height="20"
			width="20"

			alt={t('common-tooltip.bg-nhif')}
			data-bs-toggle="tooltip"
			data-placement="top"
			data-bs-title={t('common-tooltip.bg-nhif')}
			title={t('common-tooltip.bg-nhif')}
		/>
	);
}
